import React from 'react';
import { IIconProps } from '../interfaces';

const AddAllItems= (props: IIconProps) => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg"
             width={ props.width }
             height={ props.width }
             className={ props.classes }
             viewBox="0 0 27 28">
            <g fill={ props.color? props.color :"#000" } fillRule="evenodd">
                <path d="M26.988 5.487c-.072-.248-.252-.495-.47-.602L17.224.495c-.362-.177-.795-.07-1.085.213l-3.11 3.433a.996.996 0 0 0-.218.779c.072.283.253.495.505.637l7.92 3.717-7.483 3.894-9.115-4.742c-.037-.036-.109-.036-.144-.07h-.072c-.037 0-.072 0-.109-.037H4.06c-.036 0-.072 0-.108.036H3.88c-.037 0-.073.036-.11.036 0 0-.036 0-.036.036-.037.036-.072.036-.144.07l-.109.107-3.255 3.647a.921.921 0 0 0-.217.743c.036.284.217.496.433.638l2.785 1.522v6.94c0 .318.18.637.47.778l9.512 4.956c.037.036.072.036.109.036.037 0 .037.036.072.036a.459.459 0 0 0 .217.036c.073 0 .145 0 .218-.036.037 0 .037-.036.072-.036.037 0 .072-.036.109-.036l9.512-4.956c.29-.141.47-.46.47-.778l-.001-12.572 2.64-3.292c.362-.212.398-.495.362-.743zM4.422 10.302l8.028 4.176-1.771 2.62-8.283-4.495 2.026-2.301zm.687 5.805l5.424 2.938c.145.07.29.107.434.107.29 0 .58-.141.76-.39l1.122-1.664v8.426l-7.74-4v-5.417zm17.25 5.416l-7.702 4.035V14.691l7.704-4-.002 10.832zm.651-13.417l-7.81-3.68 1.844-2.054 7.632 3.61-1.666 2.124z"></path>
                <path d="M9.425 8.274c.226 0 .49-.067.678-.235L13 5.46l-1.317-1.174-1.242 1.107V2.375H8.559v3.117L7.317 4.386 6 5.559l2.784 2.48c.19.135.416.235.641.235z"></path>
            </g>
        </svg>

    )
};

export default AddAllItems;
